import { Dispatch, FC, SetStateAction, useEffect, useState } from 'react'

import classNames from 'classnames'

import s from './Quiz.module.scss'
import { TQuizStage } from './QuizPopup'

type FooterProps = {
    time: number
    isStarted: boolean
    setStage: Dispatch<SetStateAction<TQuizStage>>
    onNext: () => void
}

const Footer: FC<FooterProps> = ({ time, isStarted, setStage, onNext }) => {
    const [timeRemaining, setTimeRemaining] = useState(time)
    const [timerActive, setTimerActive] = useState(false)

    const minutes = Math.floor(timeRemaining / 60)
    const seconds = timeRemaining % 60

    useEffect(() => {
        let timerId: NodeJS.Timeout
        if (timerActive && timeRemaining > 0) {
            timerId = setInterval(() => {
                setTimeRemaining(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timerId)
                        setTimerActive(false)
                        setStage('time_out')
                        return 0
                    }
                    return prevTime - 1
                })
            }, 1000)
        }

        return () => clearInterval(timerId)
    }, [timerActive, timeRemaining])

    const startQuiz = () => {
        setTimerActive(true)
        setStage('in_progress')
    }

    return (
        <div className={s.quizPopup__footer}>
            <div className={s.timer}>
                {!isStarted && <p className={s.timer__title}>Время прохождения теста</p>}

                <div className={s.timer__time}>
                    <span>{String(minutes).padStart(2, '0')}</span> : <span>{String(seconds).padStart(2, '0')}</span>
                    <div className={s.timer__descr}>
                        <span>Минут</span>
                        <span>Секунд</span>
                    </div>
                </div>
            </div>
            <button
                type='button'
                className={classNames('button-more', s.quizPopup__btn)}
                onClick={() => (isStarted ? onNext() : startQuiz())}
            >
                {isStarted ? 'Далее' : 'Начать тест'}
            </button>
        </div>
    )
}

export default Footer
